module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-11 col-xs-11",
    staticStyle: {
      "margin-left": "4%"
    }
  }, [_c('mdb-carousel', {
    attrs: {
      "items": _vm.getPCCount(),
      "multi": "",
      "controlls": "",
      "indicators": "",
      "interval": 5000
    },
    scopedSlots: _vm._u([_vm._l((_vm.private_community), function(o, i) {
      return {
        key: i + 1,
        fn: function() {
          return [_c('mdb-card', {
            key: i,
            staticStyle: {
              "box-shadow": "none"
            }
          }, [_c('mdb-card-image', {
            attrs: {
              "src": o && o.banner && o.banner[0],
              "alt": "Card image cap"
            }
          }), _vm._v(" "), _c('mdb-card-body', [_c('mdb-card-text', {
            staticStyle: {
              "color": "#4B2D15",
              "font": "Bold 17px/21px Proxima Nova"
            }
          }, [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('mdb-card-text', [_c('img', {
            staticStyle: {
              "height": "16px",
              "margin-left": "-47%"
            },
            attrs: {
              "src": require("../../assets/images/community/ic_khoilop.svg")
            }
          }), _c('span', {
            staticStyle: {
              "height": "16px",
              "color": "#3A9F00",
              "margin-left": "-45%",
              "font": "Regular 13px/16px Proxima Nova"
            }
          }, [_vm._v(_vm._s(o.subject.name))])]), _vm._v(" "), _c('mdb-card-text', [_c('img', {
            staticStyle: {
              "height": "16px",
              "margin-left": "-47%"
            },
            attrs: {
              "src": require("../../assets/images/community/ic_thanhvien.svg")
            }
          }), _c('span', {
            staticStyle: {
              "height": "16px",
              "color": "#4B2D15",
              "margin-left": "-45%",
              "font": "Regular 13px/16px Proxima Nova"
            }
          }, [_vm._v(_vm._s(o.pc_users.length) + " thành viên")])])], 1)], 1)]
        },
        proxy: true
      }
    })], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1b6d090","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/CommunityTeacher.vue
// module id = 1638
// module chunks = 0